import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["disabled", "aria-pressed"]
const _hoisted_2 = {
  key: 0,
  class: "gfu-select-card__badges"
}
const _hoisted_3 = { class: "gfu-select-card__main _toe" }
const _hoisted_4 = {
  class: "gfu-select-card__check",
  "aria-hidden": "true"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass($options.classes),
    disabled: $props.isDisabled,
    "aria-pressed": $props.modelValue,
    onClick: _cache[0] || (_cache[0] = (...args) => ($options.onSelect && $options.onSelect(...args)))
  }, [
    ($options.hasBadges)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.badges, (badge) => {
            return (_openBlock(), _createBlock(_component_base_badge, {
              key: badge.name,
              theme: badge.theme,
              class: _normalizeClass(["_mr-1 _my-1", badge.classes]),
              "data-qa": badge.dataQa
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(badge.name), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["theme", "class", "data-qa"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("span", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, [
        ($props.modelValue)
          ? (_openBlock(), _createBlock(_component_base_icon, {
              key: 0,
              name: "check"
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _renderSlot(_ctx.$slots, "details")
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}